import React, { useState, useContext } from "react";
import RemoveIcon from "../RemoveIcon/RemoveIcon";
import EditIcon from "../EditIcon/EditIcon";
import SearchIcon from "../SearchIcon/SearchIcon";
import ToolComponent from "../../ToolComponent/ToolComponent";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import useGetPositionById from "../../../Hooks/useGetPositionById";
import "../../Styles/globalStyle.css";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Filter(props) {
  const [position, setPosition] = useState({left:0, top:0, isOpened:[], selectedValues:[]});
  const getPositionById = useGetPositionById();
  const iconWidthAndHeight = 13;
  const buildStyle = useBuildStyle();
  const getVisibleColumn = () => {
    
    var visiblesColumns = JSON.parse(JSON.stringify(props.data.metaData.filter((item) =>
      props.data.selectedValues.includes(item.headerId) 
    ))) ;
    
    
    visiblesColumns.map(column => {
      column.styles["resize"] = {value:"none"};
      /*if (props.isHeader == false){
        delete column.styles.resize; 
        delete column.styles.overflow; 
      } */
    })

    return visiblesColumns;
  };
  
  const getStyle = () => {
    var newStyle = buildStyle(props.style);
    
    
    newStyle["width"] = parseInt(newStyle.width.slice(0, -2)) - iconWidthAndHeight + "px";

    const border =  props.draggable && props.isSelected
    ? "1px dashed gray"
    : props.style.border.value
    
    newStyle["border"] = undefined
    newStyle["borderTop"] = "none";
    newStyle["borderLeft"] = "none";
    newStyle["borderRight"] = "none";
    newStyle["borderBottom"] = border;
    if (!props.draggable) newStyle["resize"] = "none"
    return newStyle;
  };

  const onClickSearchIcon = (e, id) => {
    
    const clickPosition = getPositionById(e, "Filter" +id)
    setPosition({...position, left:clickPosition[0], top:clickPosition[1] + iconWidthAndHeight + 3, isOpened:[id]})
    e.stopPropagation();
  };

  const onSelectOperator = (colId, operator, firstOperand) => {
    
    var newSelectedValues = JSON.parse(JSON.stringify(position.selectedValues))
    const selection = newSelectedValues.filter(item => item.colId == colId)[0]
    if(selection)
      if (selection.operator.id == operator.id) {
        newSelectedValues = newSelectedValues.filter(item => item.colId != colId)
      }
      else
        newSelectedValues.filter(item => item.colId == colId).forEach(item => {
          item.operator = operator;
          item.firstOperand = firstOperand
        });
        
    else
      newSelectedValues.push({colId: colId, operator:operator, firstOperand:firstOperand})

    
    
    setPosition({...position, isOpened:[], selectedValues: newSelectedValues})
    props.onSelectOperator(newSelectedValues)
  };

  const onClick = (e , data) => {
    if (position.isOpened) setPosition({...position, isOpened:[]})
      props.onClick(e, data)
  };

  return (
    <div style={getStyle()} >
      <div className="selectLineCol" onClick={(e) => onClick(e, props.data)} >
        <div
          className="colGrid"
          style={{
            borderRight: "1px solid " + props.data.styles.color.value,
            width: "30px",
          }}
        ></div>
      </div>
      <div className="controlGrid">
        {getVisibleColumn().map((template, index) => (
          <div
            className="colGrid"
            style={{ borderRight: "1px solid " + props.data.styles.color.value }}
            key={template.id}>
            <ToolComponent
              position="relative"
              meta={template}
              onlyLabel={false}
              dataGridColumn={true}
              filterable={true}
              onChange={(e, value) => props.onChange(e, value)}
              onKeyPress={(e) => props.onKeyPress(e)}
              onBlur={(e) => props.onBlur(e, template)}
              updateSize ={(id, resizeWidth, resizeHeight) =>  {return}}
              
              //onMultiselectionClick={(itemSelected) => {return}}
              //onDropColumn={(e, column) => {return}}
              //onMouseOver={(e) => props.onMouseOver(e, template)}
              onMouseEnter={(e) => props.onMouseEnter(e, template)}
              onMouseDown={(e) => props.onMouseDown(e, template)}
              onMouseLeave={(e) => props.onMouseLeave(e, template)}
              onClick={(e) => onClick(e, template)}
              onClickSearchIcon={(e) => onClickSearchIcon(e,  template.id)}
            />
            <DropDownListNew
              fontSize={template.styles.fontSize.value}
              currentData={template.properties.operators.values}
             // id={"Filter" + template.id}
              hideIcon={true}
              onlyLabel={false}
              multiSelection={true}
              position={position}
              isExternalExpanded={position.isOpened.includes(template.id)}
              selectedValues={position.selectedValues.filter(item => item.colId == template.id).map(item => item.operator.id)}
              onDropDownItemClick={(operator) => onSelectOperator(template.id, operator, {index:index, headerId:template.headerId})}/>
          </div>
        ))}
      </div>
    </div>
  );
}
